<div class="blade-wrapper">
  <div class="blade-header">
    <div *ngIf="!$hasMissingRequiredInParams" class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="confirm" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_confirm_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
            <ng-template 
              toolbarToolDef="cancel" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_cancel_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized && !$hasMissingRequiredInParams">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!fieldsets.newGroup1.hidden && !fieldsets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-name" *ngIf="!fields.name.hidden && !fields.name.removed" 
                            class="field-container double {{fields.name.invalid ? 'invalid' : ''}} {{fields.name.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.name.styles.style"
                            [ngClass]="fields.name.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.name.label + (fields.name.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.name.label}}<span *ngIf="fields.name.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="name"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.name.control.readOnly || fields.name.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.name.control.placeholder}}"
                                [ngStyle]="fields.name.control.styles.style"
                                [ngClass]="fields.name.control.styles.classes"
                                [matTooltip]="fields.name.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="fields.name.invalid">
                          <ng-container *ngFor="let error of fields.name.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-type" *ngIf="!fields.type.hidden && !fields.type.removed" 
                            class="field-container double {{fields.type.invalid ? 'invalid' : ''}} {{fields.type.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.type.styles.style"
                            [ngClass]="fields.type.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.type.label + (fields.type.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.type.label}}<span *ngIf="fields.type.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Locations-location_type_dd_single 
                            data-cy="selector"
                            [type]="fields.type.control.type"
                            formControlName="type"
                            (displayTextChange)="fields.type.control.displayText=$event"
                            [placeholder]="fields.type.control.placeholder"
                            [styles]="fields.type.control.styles"
                            [tooltip]="fields.type.control.tooltip"
                        >
                        </Locations-location_type_dd_single>
                        <ng-container *ngIf="fields.type.invalid">
                          <ng-container *ngFor="let error of fields.type.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-parent" *ngIf="!fields.parent.hidden && !fields.parent.removed" 
                            class="field-container double {{fields.parent.invalid ? 'invalid' : ''}} {{fields.parent.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.parent.styles.style"
                            [ngClass]="fields.parent.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.parent.label + (fields.parent.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.parent.label}}<span *ngIf="fields.parent.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Locations-zones_dd_single 
                            data-cy="selector"
                            [type]="fields.parent.control.type"
                            formControlName="parent"
                            (displayTextChange)="fields.parent.control.displayText=$event"
                            [placeholder]="fields.parent.control.placeholder"
                            [styles]="fields.parent.control.styles"
                            [tooltip]="fields.parent.control.tooltip"
                          [warehouseId]="$fields_parent_selector_inParams_warehouseId"
                        >
                        </Locations-zones_dd_single>
                        <ng-container *ngIf="fields.parent.invalid">
                          <ng-container *ngFor="let error of fields.parent.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-storage_category" *ngIf="!fields.storage_category.hidden && !fields.storage_category.removed" 
                            class="field-container double {{fields.storage_category.invalid ? 'invalid' : ''}} {{fields.storage_category.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.storage_category.styles.style"
                            [ngClass]="fields.storage_category.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.storage_category.label + (fields.storage_category.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.storage_category.label}}<span *ngIf="fields.storage_category.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Locations-storage_categories_dd_single 
                            data-cy="selector"
                            [type]="fields.storage_category.control.type"
                            formControlName="storage_category"
                            (displayTextChange)="fields.storage_category.control.displayText=$event"
                            [placeholder]="fields.storage_category.control.placeholder"
                            [styles]="fields.storage_category.control.styles"
                            [tooltip]="fields.storage_category.control.tooltip"
                        >
                        </Locations-storage_categories_dd_single>
                        <ng-container *ngIf="fields.storage_category.invalid">
                          <ng-container *ngFor="let error of fields.storage_category.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.newGroup1.expanded">
        
        
                    </div>
                  </div>
                </div>
                <div data-cy="fieldset-id-newGroup2"
                     *ngIf="!fieldsets.newGroup2.hidden && !fieldsets.newGroup2.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup2.collapsible }">
                    <div *ngIf="!fieldsets.newGroup2.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup2.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.newGroup2.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup2.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup2.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup2.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup2.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-is_loose" *ngIf="!fields.is_loose.hidden && !fields.is_loose.removed" 
                            class="field-container standard {{fields.is_loose.invalid ? 'invalid' : ''}} {{fields.is_loose.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.is_loose.styles.style"
                            [ngClass]="fields.is_loose.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.is_loose.label + (fields.is_loose.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.is_loose.label}}<span *ngIf="fields.is_loose.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="is_loose"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.is_loose.control.styles.style"
                                      [ngClass]="fields.is_loose.control.styles.classes"
                                      [matTooltip]="fields.is_loose.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.is_loose.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.is_loose.invalid">
                          <ng-container *ngFor="let error of fields.is_loose.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-purge_added_inventory" *ngIf="!fields.purge_added_inventory.hidden && !fields.purge_added_inventory.removed" 
                            class="field-container standard {{fields.purge_added_inventory.invalid ? 'invalid' : ''}} {{fields.purge_added_inventory.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.purge_added_inventory.styles.style"
                            [ngClass]="fields.purge_added_inventory.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.purge_added_inventory.label + (fields.purge_added_inventory.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.purge_added_inventory.label}}<span *ngIf="fields.purge_added_inventory.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="purge_added_inventory"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.purge_added_inventory.control.styles.style"
                                      [ngClass]="fields.purge_added_inventory.control.styles.classes"
                                      [matTooltip]="fields.purge_added_inventory.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.purge_added_inventory.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.purge_added_inventory.invalid">
                          <ng-container *ngFor="let error of fields.purge_added_inventory.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-confirm_empty_location" *ngIf="!fields.confirm_empty_location.hidden && !fields.confirm_empty_location.removed" 
                            class="field-container standard {{fields.confirm_empty_location.invalid ? 'invalid' : ''}} {{fields.confirm_empty_location.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.confirm_empty_location.styles.style"
                            [ngClass]="fields.confirm_empty_location.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.confirm_empty_location.label + (fields.confirm_empty_location.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.confirm_empty_location.label}}<span *ngIf="fields.confirm_empty_location.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="confirm_empty_location"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.confirm_empty_location.control.styles.style"
                                      [ngClass]="fields.confirm_empty_location.control.styles.classes"
                                      [matTooltip]="fields.confirm_empty_location.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.confirm_empty_location.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.confirm_empty_location.invalid">
                          <ng-container *ngFor="let error of fields.confirm_empty_location.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-allow_only_clps" *ngIf="!fields.allow_only_clps.hidden && !fields.allow_only_clps.removed" 
                            class="field-container standard {{fields.allow_only_clps.invalid ? 'invalid' : ''}} {{fields.allow_only_clps.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.allow_only_clps.styles.style"
                            [ngClass]="fields.allow_only_clps.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.allow_only_clps.label + (fields.allow_only_clps.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.allow_only_clps.label}}<span *ngIf="fields.allow_only_clps.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="allow_only_clps"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.allow_only_clps.control.styles.style"
                                      [ngClass]="fields.allow_only_clps.control.styles.classes"
                                      [matTooltip]="fields.allow_only_clps.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.allow_only_clps.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.allow_only_clps.invalid">
                          <ng-container *ngFor="let error of fields.allow_only_clps.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-countback_threshold" *ngIf="!fields.countback_threshold.hidden && !fields.countback_threshold.removed" 
                            class="field-container standard {{fields.countback_threshold.invalid ? 'invalid' : ''}} {{fields.countback_threshold.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.countback_threshold.styles.style"
                            [ngClass]="fields.countback_threshold.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.countback_threshold.label + (fields.countback_threshold.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.countback_threshold.label}}<span *ngIf="fields.countback_threshold.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="countback_threshold"
                                matInput
                                numberBox
                                [format]="fields.countback_threshold.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.countback_threshold.control.readOnly || fields.countback_threshold.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.countback_threshold.control.placeholder}}"
                                [ngStyle]="fields.countback_threshold.control.styles.style"
                                [ngClass]="fields.countback_threshold.control.styles.classes"
                                [matTooltip]="fields.countback_threshold.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.countback_threshold.invalid">
                          <ng-container *ngFor="let error of fields.countback_threshold.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.newGroup2.expanded">
        
        
                    </div>
                  </div>
                </div>
                <div data-cy="fieldset-id-outbound_order_settings"
                     *ngIf="!fieldsets.outbound_order_settings.hidden && !fieldsets.outbound_order_settings.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.outbound_order_settings.collapsible }">
                    <div *ngIf="!fieldsets.outbound_order_settings.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.outbound_order_settings.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.outbound_order_settings.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.outbound_order_settings.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.outbound_order_settings.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.outbound_order_settings.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.outbound_order_settings.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-eligible_for_allocation" *ngIf="!fields.eligible_for_allocation.hidden && !fields.eligible_for_allocation.removed" 
                            class="field-container standard {{fields.eligible_for_allocation.invalid ? 'invalid' : ''}} {{fields.eligible_for_allocation.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.eligible_for_allocation.styles.style"
                            [ngClass]="fields.eligible_for_allocation.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.eligible_for_allocation.label + (fields.eligible_for_allocation.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.eligible_for_allocation.label}}<span *ngIf="fields.eligible_for_allocation.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="eligible_for_allocation"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.eligible_for_allocation.control.styles.style"
                                      [ngClass]="fields.eligible_for_allocation.control.styles.classes"
                                      [matTooltip]="fields.eligible_for_allocation.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.eligible_for_allocation.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.eligible_for_allocation.invalid">
                          <ng-container *ngFor="let error of fields.eligible_for_allocation.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-is_primary" *ngIf="!fields.is_primary.hidden && !fields.is_primary.removed" 
                            class="field-container standard {{fields.is_primary.invalid ? 'invalid' : ''}} {{fields.is_primary.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.is_primary.styles.style"
                            [ngClass]="fields.is_primary.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.is_primary.label + (fields.is_primary.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.is_primary.label}}<span *ngIf="fields.is_primary.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="is_primary"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.is_primary.control.styles.style"
                                      [ngClass]="fields.is_primary.control.styles.classes"
                                      [matTooltip]="fields.is_primary.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.is_primary.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.is_primary.invalid">
                          <ng-container *ngFor="let error of fields.is_primary.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-picking_sequence" *ngIf="!fields.picking_sequence.hidden && !fields.picking_sequence.removed" 
                            class="field-container standard {{fields.picking_sequence.invalid ? 'invalid' : ''}} {{fields.picking_sequence.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.picking_sequence.styles.style"
                            [ngClass]="fields.picking_sequence.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.picking_sequence.label + (fields.picking_sequence.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.picking_sequence.label}}<span *ngIf="fields.picking_sequence.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="picking_sequence"
                                matInput
                                numberBox
                                [format]="fields.picking_sequence.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.picking_sequence.control.readOnly || fields.picking_sequence.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.picking_sequence.control.placeholder}}"
                                [ngStyle]="fields.picking_sequence.control.styles.style"
                                [ngClass]="fields.picking_sequence.control.styles.classes"
                                [matTooltip]="fields.picking_sequence.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.picking_sequence.invalid">
                          <ng-container *ngFor="let error of fields.picking_sequence.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-allocation_sequence" *ngIf="!fields.allocation_sequence.hidden && !fields.allocation_sequence.removed" 
                            class="field-container standard {{fields.allocation_sequence.invalid ? 'invalid' : ''}} {{fields.allocation_sequence.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.allocation_sequence.styles.style"
                            [ngClass]="fields.allocation_sequence.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.allocation_sequence.label + (fields.allocation_sequence.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.allocation_sequence.label}}<span *ngIf="fields.allocation_sequence.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="allocation_sequence"
                                matInput
                                numberBox
                                [format]="fields.allocation_sequence.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.allocation_sequence.control.readOnly || fields.allocation_sequence.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.allocation_sequence.control.placeholder}}"
                                [ngStyle]="fields.allocation_sequence.control.styles.style"
                                [ngClass]="fields.allocation_sequence.control.styles.classes"
                                [matTooltip]="fields.allocation_sequence.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.allocation_sequence.invalid">
                          <ng-container *ngFor="let error of fields.allocation_sequence.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.outbound_order_settings.expanded">
        
        
                    </div>
                  </div>
                </div>
                <div data-cy="fieldset-id-properties"
                     *ngIf="!fieldsets.properties.hidden && !fieldsets.properties.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.properties.collapsible }">
                    <div *ngIf="!fieldsets.properties.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.properties.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.properties.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.properties.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.properties.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.properties.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.properties.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-length" *ngIf="!fields.length.hidden && !fields.length.removed" 
                            class="field-container double {{fields.length.invalid ? 'invalid' : ''}} {{fields.length.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.length.styles.style"
                            [ngClass]="fields.length.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.length.label + (fields.length.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.length.label}}<span *ngIf="fields.length.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="length"
                                matInput
                                numberBox
                                [format]="fields.length.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.length.control.readOnly || fields.length.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.length.control.placeholder}}"
                                [ngStyle]="fields.length.control.styles.style"
                                [ngClass]="fields.length.control.styles.classes"
                                [matTooltip]="fields.length.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.length.invalid">
                          <ng-container *ngFor="let error of fields.length.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-width" *ngIf="!fields.width.hidden && !fields.width.removed" 
                            class="field-container double {{fields.width.invalid ? 'invalid' : ''}} {{fields.width.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.width.styles.style"
                            [ngClass]="fields.width.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.width.label + (fields.width.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.width.label}}<span *ngIf="fields.width.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="width"
                                matInput
                                numberBox
                                [format]="fields.width.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.width.control.readOnly || fields.width.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.width.control.placeholder}}"
                                [ngStyle]="fields.width.control.styles.style"
                                [ngClass]="fields.width.control.styles.classes"
                                [matTooltip]="fields.width.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.width.invalid">
                          <ng-container *ngFor="let error of fields.width.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-height" *ngIf="!fields.height.hidden && !fields.height.removed" 
                            class="field-container double {{fields.height.invalid ? 'invalid' : ''}} {{fields.height.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.height.styles.style"
                            [ngClass]="fields.height.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.height.label + (fields.height.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.height.label}}<span *ngIf="fields.height.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="height"
                                matInput
                                numberBox
                                [format]="fields.height.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.height.control.readOnly || fields.height.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.height.control.placeholder}}"
                                [ngStyle]="fields.height.control.styles.style"
                                [ngClass]="fields.height.control.styles.classes"
                                [matTooltip]="fields.height.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.height.invalid">
                          <ng-container *ngFor="let error of fields.height.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-dimension_uom" *ngIf="!fields.dimension_uom.hidden && !fields.dimension_uom.removed" 
                            class="field-container double {{fields.dimension_uom.invalid ? 'invalid' : ''}} {{fields.dimension_uom.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.dimension_uom.styles.style"
                            [ngClass]="fields.dimension_uom.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.dimension_uom.label + (fields.dimension_uom.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.dimension_uom.label}}<span *ngIf="fields.dimension_uom.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Locations-measurement_units_dd_single 
                            data-cy="selector"
                            [type]="fields.dimension_uom.control.type"
                            formControlName="dimension_uom"
                            (displayTextChange)="fields.dimension_uom.control.displayText=$event"
                            [placeholder]="fields.dimension_uom.control.placeholder"
                            [styles]="fields.dimension_uom.control.styles"
                            [tooltip]="fields.dimension_uom.control.tooltip"
                          [typeId]="$fields_dimension_uom_selector_inParams_typeId"
                        >
                        </Locations-measurement_units_dd_single>
                        <ng-container *ngIf="fields.dimension_uom.invalid">
                          <ng-container *ngFor="let error of fields.dimension_uom.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-weight_capacity" *ngIf="!fields.weight_capacity.hidden && !fields.weight_capacity.removed" 
                            class="field-container double {{fields.weight_capacity.invalid ? 'invalid' : ''}} {{fields.weight_capacity.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.weight_capacity.styles.style"
                            [ngClass]="fields.weight_capacity.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.weight_capacity.label + (fields.weight_capacity.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.weight_capacity.label}}<span *ngIf="fields.weight_capacity.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="weight_capacity"
                                matInput
                                numberBox
                                [format]="fields.weight_capacity.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.weight_capacity.control.readOnly || fields.weight_capacity.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.weight_capacity.control.placeholder}}"
                                [ngStyle]="fields.weight_capacity.control.styles.style"
                                [ngClass]="fields.weight_capacity.control.styles.classes"
                                [matTooltip]="fields.weight_capacity.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.weight_capacity.invalid">
                          <ng-container *ngFor="let error of fields.weight_capacity.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-weight_uom" *ngIf="!fields.weight_uom.hidden && !fields.weight_uom.removed" 
                            class="field-container double {{fields.weight_uom.invalid ? 'invalid' : ''}} {{fields.weight_uom.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.weight_uom.styles.style"
                            [ngClass]="fields.weight_uom.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.weight_uom.label + (fields.weight_uom.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.weight_uom.label}}<span *ngIf="fields.weight_uom.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Locations-measurement_units_dd_single 
                            data-cy="selector"
                            [type]="fields.weight_uom.control.type"
                            formControlName="weight_uom"
                            (displayTextChange)="fields.weight_uom.control.displayText=$event"
                            [placeholder]="fields.weight_uom.control.placeholder"
                            [styles]="fields.weight_uom.control.styles"
                            [tooltip]="fields.weight_uom.control.tooltip"
                          [typeId]="$fields_weight_uom_selector_inParams_typeId"
                        >
                        </Locations-measurement_units_dd_single>
                        <ng-container *ngIf="fields.weight_uom.invalid">
                          <ng-container *ngFor="let error of fields.weight_uom.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-volume_capacity" *ngIf="!fields.volume_capacity.hidden && !fields.volume_capacity.removed" 
                            class="field-container double {{fields.volume_capacity.invalid ? 'invalid' : ''}} {{fields.volume_capacity.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.volume_capacity.styles.style"
                            [ngClass]="fields.volume_capacity.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.volume_capacity.label + (fields.volume_capacity.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.volume_capacity.label}}<span *ngIf="fields.volume_capacity.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="volume_capacity"
                                matInput
                                numberBox
                                [format]="fields.volume_capacity.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.volume_capacity.control.readOnly || fields.volume_capacity.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.volume_capacity.control.placeholder}}"
                                [ngStyle]="fields.volume_capacity.control.styles.style"
                                [ngClass]="fields.volume_capacity.control.styles.classes"
                                [matTooltip]="fields.volume_capacity.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.volume_capacity.invalid">
                          <ng-container *ngFor="let error of fields.volume_capacity.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-volume_uom" *ngIf="!fields.volume_uom.hidden && !fields.volume_uom.removed" 
                            class="field-container double {{fields.volume_uom.invalid ? 'invalid' : ''}} {{fields.volume_uom.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.volume_uom.styles.style"
                            [ngClass]="fields.volume_uom.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.volume_uom.label + (fields.volume_uom.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.volume_uom.label}}<span *ngIf="fields.volume_uom.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Locations-measurement_units_dd_single 
                            data-cy="selector"
                            [type]="fields.volume_uom.control.type"
                            formControlName="volume_uom"
                            (displayTextChange)="fields.volume_uom.control.displayText=$event"
                            [placeholder]="fields.volume_uom.control.placeholder"
                            [styles]="fields.volume_uom.control.styles"
                            [tooltip]="fields.volume_uom.control.tooltip"
                          [typeId]="$fields_volume_uom_selector_inParams_typeId"
                        >
                        </Locations-measurement_units_dd_single>
                        <ng-container *ngIf="fields.volume_uom.invalid">
                          <ng-container *ngFor="let error of fields.volume_uom.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-child_footprint" *ngIf="!fields.child_footprint.hidden && !fields.child_footprint.removed" 
                            class="field-container double {{fields.child_footprint.invalid ? 'invalid' : ''}} {{fields.child_footprint.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.child_footprint.styles.style"
                            [ngClass]="fields.child_footprint.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.child_footprint.label + (fields.child_footprint.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.child_footprint.label}}<span *ngIf="fields.child_footprint.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="child_footprint"
                                matInput
                                numberBox
                                [format]="fields.child_footprint.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.child_footprint.control.readOnly || fields.child_footprint.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.child_footprint.control.placeholder}}"
                                [ngStyle]="fields.child_footprint.control.styles.style"
                                [ngClass]="fields.child_footprint.control.styles.classes"
                                [matTooltip]="fields.child_footprint.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.child_footprint.invalid">
                          <ng-container *ngFor="let error of fields.child_footprint.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-child_stack_height" *ngIf="!fields.child_stack_height.hidden && !fields.child_stack_height.removed" 
                            class="field-container double {{fields.child_stack_height.invalid ? 'invalid' : ''}} {{fields.child_stack_height.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.child_stack_height.styles.style"
                            [ngClass]="fields.child_stack_height.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.child_stack_height.label + (fields.child_stack_height.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.child_stack_height.label}}<span *ngIf="fields.child_stack_height.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="child_stack_height"
                                matInput
                                numberBox
                                [format]="fields.child_stack_height.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.child_stack_height.control.readOnly || fields.child_stack_height.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.child_stack_height.control.placeholder}}"
                                [ngStyle]="fields.child_stack_height.control.styles.style"
                                [ngClass]="fields.child_stack_height.control.styles.classes"
                                [matTooltip]="fields.child_stack_height.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.child_stack_height.invalid">
                          <ng-container *ngFor="let error of fields.child_stack_height.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.properties.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

      <div *ngIf="$hasMissingRequiredInParams" class="missing-params">
        <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
      </div>
    </div>
  </div>
</div>